import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: '#ffff',
    borderRadius: 4,
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '2rem',
    lineHeight: 1,
    fontWeight: 200,
    '& p': {
      fontSize: '1.2rem',
      fontWeight: 400,
      lineHeight: '1.3125rem',
      marginBottom: theme.spacing(2),
    },
  },
  leftInput: {},
  rightInput: {
    borderWidth: '1px 1px 1px 0px',
  },
  '@media screen and (min-width: 600px)': {
    root: {
      padding: `${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
      background: '#ffff',
      borderRadius: 4,
      //zIndex: 800,
      width: '100%',
    },
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'end',
  },
}));
